// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:00:38

export default {
  "id": "spinning-oia-oia-cat-bricker",
  "slug": "spinning-oia-oia-cat-bricker",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/75c07154fb2b4aafad4c5f67ddb37963-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/75c07154fb2b4aafad4c5f67ddb37963/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Spinning Uia Uia Cat Bricker",
      "description": "Spinning Uia Uia Cat Bricker is a fun and addictive brick-breaking game where a lively cat motivates you with cheerful meows. Your goal is to clear all the bricks without dropping the ball. As you break more bricks, the cat gets even more excited, dancing and playing around. With colorful graphics and dynamic gameplay, this game offers a delightful experience for players of all ages. Stay sharp and keep up!",
      "instructions": "Play with mouse.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "brick",
        "brickbreaker",
        "bricks",
        "cat"
      ]
    },
    "zh-CN": {
      "title": "旋转乌亚乌亚猫砖块",
      "description": "旋转喵喵猫砖块是一款有趣且上瘾的打砖块游戏，一只活泼的猫通过欢快的喵喵声激励你。你的目标是清空所有砖块而不让球掉落。随着你打破更多砖块，猫会变得更加兴奋，跳舞并在周围玩耍。这款游戏拥有丰富多彩的图形和动态的游戏玩法，为所有年龄段的玩家提供愉悦的游戏体验。保持警觉，跟上节奏！",
      "instructions": "使用鼠标进行游戏。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "砖块",
        "打砖块",
        "砖",
        "猫"
      ]
    },
    "zh-TW": {
      "title": "旋轉烏烏烏貓搖搖板",
      "description": "旋轉烏烏烏貓破壘是一款有趣且上癮的破壘遊戲，其中一隻活潑的貓用愉快的喵喵聲鼓勵你。你的目標是清空所有磚塊而不讓球掉落。隨著你破壞更多磚塊，貓會越來越興奮，跳躍並四處遊玩。這款遊戲擁有豐富的色彩圖形和動態遊戲玩法，為各年齡層的玩家帶來愉快的體驗。保持敏捷，跟緊腳步！",
      "instructions": "使用滑鼠玩遊戲。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "磚塊",
        "破壞磚塊",
        "磚",
        "貓"
      ]
    },
    "zh-HK": {
      "title": "旋轉烏雅烏雅貓貝克爾",
      "description": "旋轉烏烏貓搗磚遊戲是一款有趣且上癮的搗磚遊戲，其中一隻活潑的貓兒會用愉快的嘖嘖聲鼓勵你。你的目標是清空所有磚塊，不讓球掉落。當你搗破更多磚塊時，貓兒會更加興奮，跳舞並且閃爍四周。遊戲擁有豐富多樣的圖像和動態遊戲玩法，為各年齡層的玩家帶來愉悅的遊戲體驗。保持清醒，跟進！",
      "instructions": "用滑鼠玩遊戲。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "磚",
        "破磚機",
        "磚塊",
        "貓"
      ]
    },
    "ja": {
      "title": "スピニング・ユア・ユア・キャット・ブリッカーサー",
      "description": "スピニング・ユイア・ユイア・キャット・ブリッカーより楽しい、魅力的なブロック破りゲームです。活発な猫が明るい鳴き声であなたを励ます。あなたの目標は、ボールが落ちないようにすべてのブロックをクリアすることです。ブロックをさらに壊すと、猫はますます興奮し、踊り回ります。カラフルなグラフィックとダイナミックなゲームプレイで、全ての年齢層のプレイヤーに楽しめる快適な体験を提供します。鋭い目を保ち、続けよう！",
      "instructions": "マウスで遊ぶ。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "ブロック",
        "ブロックブレイカー",
        "ブロック",
        "猫"
      ]
    },
    "ko": {
      "title": "스핀 유아 유아 고양이 브리커",
      "description": "스핀 유아 유아 고양이 브릭커는 생동감 넘치는 고양이가 즐거운 미아우를 하며 동기를 부여하는 흥미진진한 브릭 브레이킹 게임입니다. 목표는 모든 브릭을 깨지 않고 공을 떨어뜨리지 않게 모두 깨는 것입니다. 브릭을 더 깨면 고양이는 더욱 기쁨을 느끼며 춤을 추고 뛰어놀기 시작합니다. 다채로운 그래픽과 동적 게임플레이로 모든 연령대의 플레이어에게 즐거운 경험을 제공합니다. 정신을 차리고 지속하세요!",
      "instructions": "마우스로 플레이하세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "브릭",
        "브릭브레이커",
        "브릭스",
        "고양이"
      ]
    },
    "fr": {
      "title": "Tournant Uia Uia Chat Bricker",
      "description": "Spinning Uia Uia Cat Bricker est un jeu de casse-tête amusant et accrocheur où un chat vivant vous motive par des miaulements joyeux. Votre objectif est de casser toutes les briques sans faire tomber la balle. Plus vous cassez de briques, plus le chat devient excité, dansant et jouant autour. Avec des graphismes colorés et un gameplay dynamique, ce jeu offre une expérience delightfull pour les joueurs de tous âges. Restez vigilant et suivez le rythme !",
      "instructions": "Joue avec la souris.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "brique",
        "brickbreaker",
        "briques",
        "chat"
      ]
    }
  }
};
